export const BASE_URI = 'http://80.87.196.68:8081';
